import React, { useState, useEffect, useRef } from 'react'

import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'

const Title = props => {
  return (
    <Row>
      <Col>
        <Form.Label style={{ fontSize: 13 }}>{props.title}</Form.Label>
      </Col>

      <Col>
        {props.required && (
          <Form.Label
            className='float-end'
            style={{
              fontSize: 10,
              color: 'red',
              fontWeight: 'bold',
              marginTop: '6px'
            }}
          >
            REQUIRED
          </Form.Label>
        )}
      </Col>
    </Row>
  )
}

export default Title
